

































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { GalleryItem } from '../interaction-plugins/gallery/gallery-interfaces';

@Component
export default class GalleryModalComponent extends Vue {
  @Prop()
  public items: GalleryItem[];

  @Prop()
  public selectedIndex: number;

  @Prop({
    default: false
  })
  public shows: boolean;

  public selectedIndexInternal: number;

  public selectedItem: GalleryItem | null = null;

  public mounted(): void {
    if (this.selectedIndex >= 0) {
      this.selectedItem = this.items[this.selectedIndex];
      this.selectedIndexInternal = this.selectedIndex;
    }

    $('body')
      .off('keydown.galleryModal')
      .on('keydown.galleryModal', (e) => {
        if (this.shows) {
          if (e.keyCode === 37) { // left
            this.pageLeft();
          } else if (e.keyCode === 39) { // right
            this.pageRight();
          } else if (e.keyCode === 27) { // esc
            this.closeModal();
          }
        }
      });
  }

  public beforeDestroy() {
    $('body').off('keydown.galleryModal');
  }

  @Watch('selectedIndex')
  public onSelectedIndexChanged(newValue: number): void {
    this.selectedIndexInternal = newValue;
    this.selectedItem = this.items[this.selectedIndexInternal];
  }

  @Emit('close')
  public closeModal() {

  }

  public isFirst(): boolean {
    return this.selectedIndexInternal === 0;
  }

  public isLast(): boolean {
    const itemsCount: number = this.items.length;
    return this.selectedIndexInternal >= itemsCount - 1;
  }

  public pageLeft() {
    if (this.isFirst()) {
      return;
    }

    this.selectedIndexInternal--;
    this.selectItem(this.selectedIndexInternal);
  }

  public pageRight() {
    if (this.isLast()) {
      return;
    }

    this.selectedIndexInternal++;
    this.selectItem(this.selectedIndexInternal);
  }

  @Emit('select')
  public selectItem(index: number) {
    this.selectedItem = this.items[index];
  }

  public imageZoom(e: any) {
    $(e.target).closest('.image__content').trigger('click');
  }
}
